module.exports = __webpack_public_path__ + "static/media/1.8d5d1fa6.jpg";